// Gift Card Media
(function() {
  function updateGiftCardImage(element, imageData) {
    const img = element.querySelector('.gift-card__image');
    const wrapper = element.querySelector('.gift-card__image-wrapper');
    const zoomBtn = element.querySelector('.gift-card__zoom-btn');

    if (img) {
      img.src = imageData.src;
      img.alt = imageData.alt;
      img.width = imageData.width;
      img.height = imageData.height;
    }

    if (wrapper) wrapper.dataset.currentImageId = imageData.id;

    if (zoomBtn) {
      zoomBtn.dataset.src = imageData.zoom_src;
      zoomBtn.dataset.pswpWidth = imageData.width;
      zoomBtn.dataset.pswpHeight = imageData.height;
    }

    element.querySelectorAll('[is="image-lazy"]').forEach(img => img.loadImage?.());
  }

  // Theme's dynamic variant path (product-info.js) never re-renders the price block,
  // so gift cards (per-variant prices) need it updated here. Scope is the PDP price
  // containers only - a document-wide sweep also rewrote the "You may also like" cards.
  function updateGiftCardPrice(element, variantData) {
    if (!variantData.price_formatted) return;

    const sectionId = element.dataset.sectionId;
    const containers = [
      ...document.querySelectorAll(`[id="price-${sectionId}"]`),
      ...document.querySelectorAll('#shopify-section-sticky-atc-bar .f-price')
    ];

    containers.forEach(container => {
      container.querySelectorAll('.f-price-item--regular, .f-price-item--sale').forEach(priceElement => {
        if (!priceElement.querySelector('*')) {
          priceElement.textContent = variantData.price_formatted;
        }
      });
    });
  }

  function initializeGiftCardZoom(element) {
    if (!window.FoxTheme?.PhotoSwipeLightbox) return;

    const zoomBtn = element.querySelector('.gift-card__zoom-btn');
    if (!zoomBtn) return;

    if (element.lightbox) element.lightbox.destroy();

    element.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
      dataSource: [{
        id: '0',
        src: zoomBtn.dataset.src,
        width: parseInt(zoomBtn.dataset.pswpWidth) || 1000,
        height: parseInt(zoomBtn.dataset.pswpHeight) || 1000,
        mediaType: 'image'
      }],
      pswpModule: window.FoxTheme.PhotoSwipe,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: true,
      close: true,
      counter: false,
      preloader: false
    });

    zoomBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (window.innerWidth <= 767) {
        // Mobile requires double-tap to prevent accidental zooms
        element.clickCount = (element.clickCount || 0) + 1;
        if (element.clickCount === 1) {
          element.clickTimer = setTimeout(() => element.clickCount = 0, 300);
        } else if (element.clickCount === 2) {
          clearTimeout(element.clickTimer);
          element.clickCount = 0;
          element.lightbox.loadAndOpen(0);
        }
      } else {
        element.lightbox.loadAndOpen(0);
      }
    };

    element.lightbox.init();
  }

  function handleGiftCardVariantChange(event) {
    const variant = event.detail?.variant;
    if (!variant?.id) return;

    document.querySelectorAll('gift-card-media').forEach(giftCardElement => {
      const productId = giftCardElement.dataset.productId;
      const variantData = window.giftCardVariants?.[productId]?.[variant.id];
      
      if (variantData) {
        if (variantData.image) {
          updateGiftCardImage(giftCardElement, variantData.image);
          if (giftCardElement.dataset.enableImageZoom === 'true') {
            initializeGiftCardZoom(giftCardElement);
          }
        }

        updateGiftCardPrice(giftCardElement, variantData);
      }
    });
  }

  document.addEventListener('variant:changed', handleGiftCardVariantChange);

  if (!customElements.get('gift-card-media')) {
    customElements.define('gift-card-media', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enableImageZoom === 'true') {
          initializeGiftCardZoom(this);
        }
      }

      disconnectedCallback() {
        if (this.lightbox) this.lightbox.destroy();
      }
    });
  }

})();